import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';

import { ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { IDataSourceDetailInfo } from '~src/datasource/models/IDataSourceInfo';
import { getDatasourceDetailInfo,replaceDatasourceIdWithConnectionIdForMixedContent } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { GeocodeDatasourceAction } from '../actions/GeocodeDatasourceAction';
import { LaunchGeocodingRecordDialog } from '../components/recordDialog/GeocodingRecordDialog';

export function* handleGeocodeDatasourceAction(action: GeocodeDatasourceAction): SagaIterator {
  const mutatableContentInfo: IContentInfo[] = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.contentInfo]);
  const datasourceDetailInfo: IDataSourceDetailInfo = yield call(getDatasourceDetailInfo, mutatableContentInfo[0].id);

  yield call(openGeocodingRecordDialog, datasourceDetailInfo);

}

export function openGeocodingRecordDialog(datasourceDetailInfo: IDataSourceDetailInfo) {
  if (FeatureFlags.geocodingExtension) {
    ReactModalService.openCustom(LaunchGeocodingRecordDialog({datasourceName: datasourceDetailInfo.name, datasourceLuid: datasourceDetailInfo.datasourceLuid || datasourceDetailInfo.luid}));
  }
}
